import { render, staticRenderFns } from "./TextCell.vue?vue&type=template&id=3280c8bb&"
import script from "./TextCell.vue?vue&type=script&lang=js&"
export * from "./TextCell.vue?vue&type=script&lang=js&"
import style0 from "./TextCell.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports